<div class="bary-table-list py-4 table-responsive">
  <table mdbTable [small]="true" [hover]="true">
    <thead>
      <tr class="tr-align-center grey-text">
        <th *ngIf="tableOptions?.isModerator"></th>
        <th colspan="2" class="tab-title text-center">
          <span jhiTranslate="baryApp.quotations.pickup">Pickup</span> -
          <span jhiTranslate="baryApp.quotations.delivery">Delivery</span>
        </th>
        <th colspan="4" class="tab-title text-center" jhiTranslate="baryApp.quotations.items">Items</th>
        <th colspan="4" class="tab-title text-center" jhiTranslate="baryApp.quotations.info">Info</th>
      </tr>
      <tr [(ascending)]="pagination.reverse" [(predicate)]="pagination.predicate" #headers (sortChange)="transition()" jhiSort>
        <th jhiSortBy="client" *ngIf="tableOptions?.isModerator">
          <span jhiTranslate="baryApp.quotations.client">Client</span>
        </th>
        <th>
          <div class="row">
            <span class="mr-3" jhiTranslate="LABEL.PICKUP_DATE">Pickup Date</span>
          </div>
          <div class="row">
            <span jhiTranslate="LABEL.DELIVERY_DATE">Delivery Date</span>
          </div>
        </th>
        <th>
          <div class="row">
            <span jhiTranslate="LABEL.PICKUP_LOCATION">Pickup Location</span>
          </div>
          <div class="row">
            <span jhiTranslate="LABEL.DELIVERY_LOCATION">Pickup Location</span>
          </div>
        </th>
        <th jhiSortBy="totalUM">
          <span class="no-capitalize" jhiTranslate="LABEL.UM">Total UM</span>
        </th>
        <th jhiSortBy="totalWeight">
          <span jhiTranslate="LABEL.WEIGHT">Total Weight</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="totalVolume">
          <span jhiTranslate="baryApp.quotations.totalVolume">Total Volume</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th *ngIf="isPriceVisible()">
          <span class="no-capitalize" jhiTranslate="baryApp.quotations.priceTTC">Price</span>
        </th>
        <th jhiSortBy="pickupReference">
          <span jhiTranslate="baryApp.quotations.pickupReference">Pickup Reference</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th jhiSortBy="quotationStatus">
          <span jhiTranslate="baryApp.quotations.status">Status</span>
          <fa-icon icon="sort"></fa-icon>
        </th>
        <th *ngIf="tableOptions?.state === 'ONGOING'">
          <span jhiTranslate="baryApp.quotations.validityDate"></span>
        </th>
        <th class="text-center p-1" *ngIf="tableOptions?.isModerator && tableOptions?.state !== 'NEW'">
          <span jhiTranslate="unvalidatedBaskets.list.head.events"></span>
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody *ngFor="let transport of transports; trackBy: trackId">
      <tr mdbTableRow>
        <td *ngIf="tableOptions?.isModerator">
          <a [routerLink]="[PATHS.MIDDLE_CUSTOMER_ID_DATA.withId(transport.customerId)]">
            {{ transport.customerName }}
          </a>
        </td>
        <td>
          <div class="row">
            <span>{{ transport.pickupDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="row">
            <span>{{ transport.deliveryDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
          </div>
        </td>
        <td>
          <div class="row">
            <span class="no-capitalize">{{ transport.pickupAddressCity ? transport.pickupAddressCity : '' }} , {{ transport.pickupAddressCountry | countryName }}</span>
          </div>
          <div class="row">
            <span class="no-capitalize">{{ transport.deliveryAddressCity ? transport.deliveryAddressCity : '' }} , {{ transport.deliveryAddressCountry | countryName }}</span>
          </div>
        </td>
        <td>
          <span [mdbTooltip]="getTotalUMTooltip(transport)">{{ totalUM(transport) }}</span>
        </td>
        <td>
          <span>{{ transport.totalWeight }} kg</span>
        </td>
        <td>
          <span>{{ transport.totalVolume }} m3</span>
        </td>
        <td *ngIf="isPriceVisible()">
          <span *ngIf="transport.quotationStatus && transport.quotationPriceHT && transport.quotationPriceHT > 0">{{
            calculatePriceTTCFromPriceHT(transport.quotationPriceHT) | currency: 'EUR'
          }}</span>
        </td>
        <td>
          <span>{{ transport.pickupReference ?? '/' }}</span>
        </td>
        <td>
          <mdb-badge
            [pill]="true"
            *ngIf="isNew(transport.quotationStatus) || isTransporterAccepted(transport.quotationStatus)"
            [info]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
          <mdb-badge
            [pill]="true"
            *ngIf="isCustomerAccepted(transport.quotationStatus)"
            [success]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
          <mdb-badge
            [pill]="true"
            *ngIf="isPayed(transport.quotationStatus)"
            [success]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
          <mdb-badge
            [pill]="true"
            *ngIf="isTransporterRejected(transport.quotationStatus) || isCustomerRejected(transport.quotationStatus)"
            [danger]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
          <mdb-icon
            *ngIf="(isTransporterRejected(transport.quotationStatus) || isCustomerRejected(transport.quotationStatus)) && transport.quotationRejectionMessage"
            [mdbTooltip]="'baryApp.quotationStatus.cause' | translate: { cause: transport.quotationRejectionMessage }"
            fas
            icon="info-circle"
            class="mr-1"
          ></mdb-icon>
          <mdb-badge
            [pill]="true"
            *ngIf="isCustomerAcceptedButExpired(transport.quotationStatus) || isCustomerExpired(transport.quotationStatus)"
            [warning]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
          <mdb-badge
            [pill]="true"
            *ngIf="isTransporterExpired(transport.quotationStatus)"
            [warning]="true"
            jhiTranslate="{{ 'baryApp.quotationStatus.' + get18nPath(transport.quotationStatus) }}"
            >{{ transport.quotationStatus }}
            >
          </mdb-badge>
        </td>
        <td *ngIf="tableOptions?.state === 'ONGOING'">
          <span>{{ transport.quotationValidityDate?.toDate() | date: 'dd/MM/yyyy' }}</span>
        </td>
        <td class="text-center p-1" *ngIf="tableOptions?.isModerator && tableOptions?.state !== 'NEW'">
          <ng-container *ngIf="(transport?.salesSupportActionsList || []).length > 0">
            <div
              *ngFor="let salesSupportAction of transport.salesSupportActionsList?.reverse() | slice: 0:1"
              jhiTranslate="{{ 'unvalidatedBaskets.error-shorty.' + salesSupportAction.typeSalesSupportActionsEnum }}"
              [translateValues]="{ date: getObjectFromJson(salesSupportAction.value).date, commercialFullName: getObjectFromJson(salesSupportAction.value).commercialFullName }"
            ></div>
            <a
              class="my-2 text-primary cursor-pointer"
              *ngIf="(transport?.salesSupportActionsList || []).length > 1"
              (click)="displayMoreEvent(transport.salesSupportActionsList!)"
              >{{ 'LABEL.SHOW_MORE' | translate }}</a
            >
          </ng-container>
        </td>
        <td class="p-1">
          <jhi-bary-cta [actions]="getCta(transport)" [idCypress]="transport.id + ''" (selectAction)="onSelectAction($event, transport)"></jhi-bary-cta>
        </td>
      </tr>
    </tbody>
    <tbody>
      <tr *ngIf="cols && cols > 0" [hidden]="transports && transports.length > 0">
        <td [colSpan]="cols" class="table-data-not-found">
          <div class="text-center">
            <p class="lead p-5" jhiTranslate="baryApp.quotations.noData">No quotation</p>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>
